export default "//file.bilionpass.com/japandx-web/0.0.1/static/language.eb6b56de-255f4b.svg";